/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MoveIcon = ({ width = 24, height = 24, hidden = false, title = 'Move' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M34 18a.5.5 0 0 0-.113-.316L32 16.029V16h-.033l-2.113-1.853A.49.49 0 0 0 29.5 14a.5.5 0 0 0-.5.5V16h-9V7h1.5a.5.5 0 0 0 .5-.5.489.489 0 0 0-.147-.35L20 4.033V4h-.029l-1.655-1.887a.5.5 0 0 0-.632 0L16.029 4H16v.033l-1.853 2.113A.489.489 0 0 0 14 6.5a.5.5 0 0 0 .5.5H16v9H7v-1.5a.5.5 0 0 0-.5-.5.49.49 0 0 0-.35.147L4.033 16H4v.029l-1.887 1.655a.5.5 0 0 0 0 .632L4 19.971V20h.033l2.113 1.852A.491.491 0 0 0 6.5 22a.5.5 0 0 0 .5-.5V20h9v9h-1.5a.5.5 0 0 0-.5.5.487.487 0 0 0 .147.35L16 31.967V32h.029l1.655 1.887a.5.5 0 0 0 .632 0L19.971 32H20v-.033l1.853-2.114A.487.487 0 0 0 22 29.5a.5.5 0 0 0-.5-.5H20v-9h9v1.5a.5.5 0 0 0 .5.5.491.491 0 0 0 .35-.148L31.967 20H32v-.029l1.887-1.655A.5.5 0 0 0 34 18Z"
    />
  </svg>`;
};
